import { useFormikContext } from 'formik';

import { DemographicFormData } from '../../../../util/demographics';

import FormCheckbox from 'components/common/forms/FormCheckbox';
import FormFieldError from 'components/common/forms/FormFieldError';

export const InboundCensusOptions = (): JSX.Element => {
  const { errors } = useFormikContext<DemographicFormData>();
  const inboundCensusErrors = errors?.audienceProfile?.inboundCensus as
    | Record<string, string>
    | undefined;

  // Extract unique error messages to avoid duplicates
  const uniqueErrorMessages = inboundCensusErrors
    ? [...new Set(Object.values(inboundCensusErrors))]
    : [];

  return (
    <div className="flex flex-col space-y-4">
      <FormCheckbox
        checkboxLabel="Region"
        name="audienceProfile.inboundCensus.useRegion"
      />
      <FormCheckbox
        checkboxLabel="Gender"
        name="audienceProfile.inboundCensus.useGender"
      />
      <FormCheckbox
        checkboxLabel="Hispanic"
        name="audienceProfile.inboundCensus.useEthnicity"
      />
      <FormCheckbox
        checkboxLabel="Race"
        name="audienceProfile.inboundCensus.useRace"
      />
      <FormCheckbox
        checkboxLabel="Age"
        name="audienceProfile.inboundCensus.useAge"
      />
      <FormCheckbox
        checkboxLabel="Household Income"
        name="audienceProfile.inboundCensus.useHHI"
      />
      {/* Display error messages in a single block */}
      {uniqueErrorMessages.length > 0 && (
        <div className="mt-2">
          {uniqueErrorMessages.map((message, index) => (
            <FormFieldError key={index} error={message} />
          ))}
        </div>
      )}
    </div>
  );
};
